module.exports = __webpack_public_path__ + "img/keluarga_lapar.26562c2b.jpeg";